<template>
    <LocationDetails/>
</template>
<script>
import LocationDetails from '../../components/locations/LocationDetails';

export default {
  components: {
    LocationDetails,
  },
};
</script>
